import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'baseline',
    color: theme.palette.textAlt,
    marginBottom: '0.75rem',
    paddingBottom: '0.5rem',
    borderBottom: 'solid 1px lightgrey',

    '& > input': {
      marginRight: '0.125rem',
      border: 'none',
      outline: 'none'
    },

    '& .delete': {
      cursor: 'pointer'
    }
  },

  label: {
    width: 120,
    marginRight: '0.5rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  answerContainer: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'flex-start',
    width: 175,

    '& i': {
      cursor: 'default',
      color: 'grey',
      fontSize: theme.size.sm
    }
  },

  drag: {
    marginRight: '0.5rem',
    cursor: 'pointer',
    height: '100%',
    paddingTop: '1px'
  },

  drop: {
    position: 'absolute',
    left: '0',
    border: '3px solid transparent',
    boxSizing: 'border-box',
    width: 'calc(154px + 2rem)'
  },

  dropTop: {
    top: 'calc(-0.75rem / 2)',
    bottom: '100%',
    borderBottomColor: ({ isOverTop }) =>
      isOverTop ? 'lightgray' : 'transparent'
  },

  dropBottom: {
    bottom: 'calc(-0.75rem / 2)',
    top: '100%',
    borderTopColor: ({ isOverBottom }) =>
      isOverBottom ? 'lightgray' : 'transparent'
  }
}))

export default useStyles
